import { Contract, Product } from "#/types";
import { Dispatch } from "react";

export interface ContextProps<T, P> {
  state: T;
  dispatch: Dispatch<P>;
}

export enum ActionTypes {
  SET_LOADING = "SET_LOADING",
  SET_PRODUCTS = "SET_PRODUCTS",
  SET_PRODUCT = "SET_PRODUCT",
  SET_CONTRACT = "SET_CONTRACT",
  DELETE_DEPENDENT = "DELETE_DEPENDENT",
}

export type GlobalAction =
  | {
      type: ActionTypes.SET_LOADING;
      payload: boolean;
    }
  | {
      type: ActionTypes.SET_PRODUCTS;
      payload: Product[];
    }
  | {
      type: ActionTypes.SET_PRODUCT;
      payload: Product;
    }
  | {
      type: ActionTypes.SET_CONTRACT;
      payload: Contract;
    }
  | {
      type: ActionTypes.DELETE_DEPENDENT;
      payload: string;
    };

export interface GlobalState {
  products?: Product[];
  selectedProduct?: Product;
  contract?: Contract;
  isLoading: boolean;
}

export interface GlobalContextProps
  extends ContextProps<GlobalState, GlobalAction> {}
